/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { GlobalAttributeDefinition } from '../model/globalAttributeDefinition';
import { GlobalAttributeDefinitionCreateRequest } from '../model/globalAttributeDefinitionCreateRequest';
import { GlobalAttributeDefinitionKeys } from '../model/globalAttributeDefinitionKeys';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class GlobalAttributeDefinitionService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createGlobalAttributeDefinition
     * Creates a new global Attribute Definition.
     * @param globalAttributeDefinitionCreateRequest the information needed to create the global Attribute Definition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public globalAttributeDefinitionCreateGlobalAttributeDefinition(globalAttributeDefinitionCreateRequest: GlobalAttributeDefinitionCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<GlobalAttributeDefinition>;
    public globalAttributeDefinitionCreateGlobalAttributeDefinition(globalAttributeDefinitionCreateRequest: GlobalAttributeDefinitionCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GlobalAttributeDefinition>>;
    public globalAttributeDefinitionCreateGlobalAttributeDefinition(globalAttributeDefinitionCreateRequest: GlobalAttributeDefinitionCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GlobalAttributeDefinition>>;
    public globalAttributeDefinitionCreateGlobalAttributeDefinition(globalAttributeDefinitionCreateRequest: GlobalAttributeDefinitionCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (globalAttributeDefinitionCreateRequest === null || globalAttributeDefinitionCreateRequest === undefined) {
            throw new Error('Required parameter globalAttributeDefinitionCreateRequest was null or undefined when calling globalAttributeDefinitionCreateGlobalAttributeDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<GlobalAttributeDefinition>(`${this.configuration.basePath}/globalAttributeDefinitions`,
            globalAttributeDefinitionCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteGlobalAttributeDefinition
     * Deletes an existing global Attribute Definition.
     * @param globalAttributeDefinitionLevel the global Attribute Definition level
     * @param globalAttributeDefinitionName the global Attribute Definition name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public globalAttributeDefinitionDeleteGlobalAttributeDefinition(globalAttributeDefinitionLevel: string, globalAttributeDefinitionName: string, observe?: 'body', reportProgress?: boolean): Observable<GlobalAttributeDefinition>;
    public globalAttributeDefinitionDeleteGlobalAttributeDefinition(globalAttributeDefinitionLevel: string, globalAttributeDefinitionName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GlobalAttributeDefinition>>;
    public globalAttributeDefinitionDeleteGlobalAttributeDefinition(globalAttributeDefinitionLevel: string, globalAttributeDefinitionName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GlobalAttributeDefinition>>;
    public globalAttributeDefinitionDeleteGlobalAttributeDefinition(globalAttributeDefinitionLevel: string, globalAttributeDefinitionName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (globalAttributeDefinitionLevel === null || globalAttributeDefinitionLevel === undefined) {
            throw new Error('Required parameter globalAttributeDefinitionLevel was null or undefined when calling globalAttributeDefinitionDeleteGlobalAttributeDefinition.');
        }
        if (globalAttributeDefinitionName === null || globalAttributeDefinitionName === undefined) {
            throw new Error('Required parameter globalAttributeDefinitionName was null or undefined when calling globalAttributeDefinitionDeleteGlobalAttributeDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<GlobalAttributeDefinition>(`${this.configuration.basePath}/globalAttributeDefinitions/globalAttributeDefinitionLevels/${encodeURIComponent(String(globalAttributeDefinitionLevel))}/globalAttributeDefinitionNames/${encodeURIComponent(String(globalAttributeDefinitionName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getGlobalAttributeDefinition
     * Get an existing global Attribute Definition.
     * @param globalAttributeDefinitionLevel the global Attribute Definition level
     * @param globalAttributeDefinitionName the global Attribute Definition name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public globalAttributeDefinitionGetGlobalAttributeDefinition(globalAttributeDefinitionLevel: string, globalAttributeDefinitionName: string, observe?: 'body', reportProgress?: boolean): Observable<GlobalAttributeDefinition>;
    public globalAttributeDefinitionGetGlobalAttributeDefinition(globalAttributeDefinitionLevel: string, globalAttributeDefinitionName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GlobalAttributeDefinition>>;
    public globalAttributeDefinitionGetGlobalAttributeDefinition(globalAttributeDefinitionLevel: string, globalAttributeDefinitionName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GlobalAttributeDefinition>>;
    public globalAttributeDefinitionGetGlobalAttributeDefinition(globalAttributeDefinitionLevel: string, globalAttributeDefinitionName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (globalAttributeDefinitionLevel === null || globalAttributeDefinitionLevel === undefined) {
            throw new Error('Required parameter globalAttributeDefinitionLevel was null or undefined when calling globalAttributeDefinitionGetGlobalAttributeDefinition.');
        }
        if (globalAttributeDefinitionName === null || globalAttributeDefinitionName === undefined) {
            throw new Error('Required parameter globalAttributeDefinitionName was null or undefined when calling globalAttributeDefinitionGetGlobalAttributeDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<GlobalAttributeDefinition>(`${this.configuration.basePath}/globalAttributeDefinitions/globalAttributeDefinitionLevels/${encodeURIComponent(String(globalAttributeDefinitionLevel))}/globalAttributeDefinitionNames/${encodeURIComponent(String(globalAttributeDefinitionName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getGlobalAttributeDefinitions
     * Retrieves all global Attribute Definitions.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public globalAttributeDefinitionGetGlobalAttributeDefinitions(observe?: 'body', reportProgress?: boolean): Observable<GlobalAttributeDefinitionKeys>;
    public globalAttributeDefinitionGetGlobalAttributeDefinitions(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GlobalAttributeDefinitionKeys>>;
    public globalAttributeDefinitionGetGlobalAttributeDefinitions(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GlobalAttributeDefinitionKeys>>;
    public globalAttributeDefinitionGetGlobalAttributeDefinitions(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<GlobalAttributeDefinitionKeys>(`${this.configuration.basePath}/globalAttributeDefinitions`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
